import React from 'react';
import { matchPath } from 'react-router-dom';
import { memoize } from 'lodash/function';

const getMatchParams = memoize(
    (path, routeId, routerResolver) => {
        const match = matchPath(path, {
            path: routerResolver.findRouteById(routeId).path,
        });

        return (match && match.params) || {};
    },
    (path, routeId) => `${path}_${routeId}`,
);

const withPathParams = routerResolver => routeId => WrappedComponent => (props) => {
    const { location: { pathname } } = props;
    return <WrappedComponent pathParams={getMatchParams(pathname, routeId, routerResolver)} {...props} />;
};

export default withPathParams;

export {
    getMatchParams,
};
